module.exports = {
	getChartColorTheme: function(chartType) {
		var am4core = window.am4core;
		if (chartType === 'Prognosis') {
			return [
				am4core.color('#0071b9'),
				am4core.color('#0071b9'),
				am4core.color('#c5eafc'),
				am4core.color('#008EE6'),
				am4core.color('#0B4260')
			];
		} else {
			return [
				am4core.color('#0071B9'),
				am4core.color('#B91E2B'),
				am4core.color('#5FB4F3'),
				am4core.color('#F59A00'),
				am4core.color('#109784'),
				am4core.color('#7BD1B8'),
				am4core.color('#E9530E'),
				am4core.color('#F4D658'),
				am4core.color('#8D70B0'),
				am4core.color('#033E93')
			];
		}
	}
};
